module.exports = __webpack_public_path__ + "img/file_png.a72522c6.png";